export default "__VITE_ASSET__770dd0b5__"